
export const SET_MSG = 'FOLHAR_MSG';
export const SET_EDITAR = 'FOLHAR_EDITAR';
export const SET_LISTA = 'FOLHAR_LISTA';
export const SET_PESQUISA = 'FOLHAR_PESQUISA';
export const SET_SERVICO = 'FOLHAR_SERVICO';
export const SET_GERAL = 'FOLHAR_GERAL';
export const SET_VALORCALCULO = 'FOLHAR_VALORCALCULO';
export const SET_VALORCALCULO_GERAL = 'FOLHAR_VALORCALCULO_GERAL';
export const SET_COMISSIONADOR = 'FOLHAR_COMISSIONADOR';
export const SET_DIAS = 'FOLHAR_DIAS';
export const SET_BASECALCULO = 'FOLHAR_BASECALCULO';
export const SET_FOLHAR_ID = 'FOLHAR_FOLHAR_ID';
export const SET_QUINZENA = 'FOLHAR_QUINZENA';
export const SET_EVENTO = 'FOLHAR_EVENTO';
export const SET_BANCOS = 'FOLHAR_BANCOS';
export const SET_RUBLICAS = 'FOLHAR_RUBLICAS';
export const SET_TOMADORES = 'FOLHAR_TOMADORES';
export const SET_AUTOMATICO = 'FOLHAR_AUTOMATICO';
export const SET_DIASUTEIS = 'FOLHAR_DIASUTEIS';
export const SET_DIASNAOUTEIS = 'FOLHAR_DIASNAOUTEIS';
export const SET_FERIADO = 'FOLHAR_FERIADO';
export const SET_FOLHAS = 'FOLHAR_FOLHAS';
export const SET_CONFIGTRABALHADOR = 'FOLHAR_CONFIGTRABALHADOR';
export const SET_TRABALHADORES = 'FOLHAR_TRABALHADORES';
export const SET_BOLETIM = 'FOLHAR_BOLETIM';